import React from 'react';

function NoDataComponent({text = I18n.t('no_data_available'), height = '100%', className = '' }) {
  return <div className={`no-data-component ${className}`} style={{height: height}}>
    <div></div>
    <p>{text}</p>
  </div>
}

export default NoDataComponent;